module.exports = __webpack_public_path__ + "static/img/组 2836.76680f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/组 2836.png
// module id = IUCE
// module chunks = 0